export enum EditorMode {
	select = 'select',
	pan = 'pan',
	addVertex = 'addVertex',
	addBlock = 'addBlock',
}
